import React from 'react'

const ClickAndCollectBrand = ({ className = '', width = '1em', height = '1em', ...props }) => (
  <svg
    className={`ac-icon ac-icon__click-and-collect-logo ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 42 22'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fill='#7B1970'
      d='M11.57 2.8l-2.12.22.08-.23c.28-.8.02-1.13-.57-1.13s-1.08.33-1.36 1.13L6.68 5.4c-.28.8-.03 1.13.56 1.13.6 0 1.08-.32 1.37-1.13l.04-.11h2.04l-.04.11a3.98 3.98 0 0 1-3.99 2.78c-1.7 0-2.7-.85-2-2.84l.88-2.5a4.05 4.05 0 0 1 4-2.83c1.7 0 2.73.8 2.03 2.78m4.79 3.63l-.81 1.65h-4.88l2.8-7.94h2.04L13.3 6.42h3.06m2.27 1.64H16.6L19.4.13h2.04l-2.8 7.93M27.7 2.8l-2.13.23.08-.23c.29-.8.03-1.13-.56-1.13s-1.08.33-1.36 1.13L22.8 5.4c-.29.8-.03 1.13.56 1.13s1.08-.32 1.36-1.13l.04-.11h2.05l-.04.11a3.98 3.98 0 0 1-3.99 2.78c-1.7 0-2.7-.85-2-2.84l.87-2.5c.7-1.98 2.3-2.83 4.01-2.83s2.73.8 2.03 2.78m3.44 5.27l-1.07-3.49-1.23 3.5H26.8L29.6.12h2.04l-1.2 3.39 3.5-3.4h2.35l-4.12 3.82 1.43 4.13h-2.46'
    />
    <path
      fill='#D8232A'
      d='M40.47 2.26c-.12.34.05.69.32 1 .83-.41 1.28-.74 1.42-1.13.15-.44-.12-.7-.62-.7-.45 0-.94.33-1.08.71l-.04.12zm.09 4.1l-.97-1.14c-.35.24-.54.44-.63.69l-.03.08c-.14.4.1.66.6.66.34 0 .68-.1 1.03-.29zm.87 1.02a5.1 5.1 0 0 1-2.73.8c-1.55 0-2.29-.84-1.84-2.1l.02-.06c.32-.9 1.1-1.44 1.88-1.82a2.09 2.09 0 0 1-.27-1.94l.02-.06C38.95.95 40.34.01 42.04.01c1.88 0 2.19 1.16 1.88 2.03-.37 1.05-1.43 1.73-2.3 2.16l.6.69c.2-.25.39-.51.55-.8h1.7c-.37.56-.81 1.2-1.35 1.82l.8.9L42.2 8.3l-.77-.9z'
    />
    <path
      fill='#7B1970'
      d='M7.14 11.7L5 11.94l.08-.22c.29-.81.03-1.14-.56-1.14s-1.08.33-1.36 1.13l-.92 2.61c-.29.8-.03 1.14.56 1.14s1.08-.33 1.37-1.14l.04-.11h2.04l-.04.11c-.7 1.99-2.29 2.78-3.99 2.78s-2.7-.85-2-2.83l.88-2.5c.7-1.98 2.3-2.83 4-2.83s2.73.79 2.03 2.77'
    />
    <path
      fill='#7B1970'
      d='M9.97 11.7l-.92 2.61c-.28.8-.02 1.14.56 1.14.6 0 1.09-.33 1.37-1.14l.92-2.6c.28-.81.03-1.14-.56-1.14s-1.08.33-1.37 1.13zm3.95.06l-.88 2.5a4.06 4.06 0 0 1-4 2.83c-1.7 0-2.71-.85-2.01-2.83l.88-2.5c.7-1.98 2.3-2.83 4-2.83s2.71.85 2.01 2.83zm5.03 3.57l-.8 1.65h-4.88l2.8-7.94h2.04l-2.22 6.3h3.06m5.93 0l-.81 1.64h-4.88L22 9.04h2.04l-2.22 6.3h3.07m4.5-4.66l-.5 1.42h2.92l-.58 1.65h-2.93l-.56 1.58h3.3l-.59 1.65h-5.33l2.8-7.94h5.33l-.58 1.64h-3.29'
    />
    <path
      fill='#7B1970'
      d='M39.1 11.7l-2.11.23.08-.22c.28-.81.02-1.14-.57-1.14s-1.08.33-1.36 1.14l-.92 2.6c-.29.8-.03 1.14.56 1.14s1.08-.33 1.37-1.14l.04-.11h2.04l-.04.11c-.7 1.99-2.29 2.78-3.99 2.78s-2.7-.85-2-2.83l.88-2.5c.7-1.98 2.3-2.83 4-2.83s2.73.79 2.03 2.77m5.91-1.02h-1.41l-2.22 6.3h-2.04l2.22-6.3h-1.65l.58-1.64h5.33l-.8 1.64'
    />
  </svg>
)

export default ClickAndCollectBrand
